(ns nosco.ui.text
  (:require
   [hx.react :refer [defnc]]
   [clojure.string :as string]
   [nosco.react :as nosco-react]))


(def -text-variants
  (concat
   (for [size ["X-Large" "X-Large/Strong" "Large" "Large/Strong" "Medium" "Small" "Subheading"]]
     (str "Heading/" size))
   (for [size ["Small" "Large"]
         length ["Short" "Long"]
         weight ["Default" "Strong"]]
     (str "Body/" size "/" length "/" weight))
   (for [weight ["Default" "Strong"]]
     (str "Caption/" weight))
   ["Label" "Button"]))

(comment
  (cons 'do
        (for [t -text-variants
              :let [name (symbol (string/replace t "/" "-"))]]
          `(def ~name ~t)))
  )

(do
  (def Heading-X-Large "Heading/X-Large")
  (def Heading-X-Large-Strong "Heading/X-Large/Strong")
  (def Heading-Large "Heading/Large")
  (def Heading-Large-Strong "Heading/Large/Strong")
  (def Heading-Medium "Heading/Medium")
  (def Heading-Small "Heading/Small")
  (def Heading-Subheading "Heading/Subheading")
  (def Body-Small-Short-Default "Body/Small/Short/Default")
  (def Body-Small-Short-Strong "Body/Small/Short/Strong")
  (def Body-Small-Long-Default "Body/Small/Long/Default")
  (def Body-Small-Long-Strong "Body/Small/Long/Strong")
  (def Body-Large-Short-Default "Body/Large/Short/Default")
  (def Body-Large-Short-Strong "Body/Large/Short/Strong")
  (def Body-Large-Long-Default "Body/Large/Long/Default")
  (def Body-Large-Long-Strong "Body/Large/Long/Strong")
  (def Caption-Default "Caption/Default")
  (def Caption-Strong "Caption/Strong")
  (def Label "Label")
  (def Button "Button"))

;; TODO investigate usages of these and replace as-needed
(def ^:deprecated Body-Short-Default Body-Small-Short-Default)
(def ^:deprecated Body-Short-Strong Body-Small-Short-Strong)
(def ^:deprecated Body-Long-Default Body-Small-Long-Default)
(def ^:deprecated Body-Large-Default Body-Large-Long-Default)
(def ^:deprecated Body-Large-Strong Body-Large-Long-Strong)


;; TODO: Formalize the definition a bit more, and move to a different namespace
(defn classnames
  "Takes a base CSS class (string), and a list of maps where map keys are
   CSS modifiers parts (starting with --) and map values are booleans.

   For map keys where values are true, the CSS modifiers are included
   with the base CSS class prepended to each modifier.

   A list of CSS classes (as strings) is returned"
  [base & rest]
  (let [m (apply merge rest)]
    (conj
     (map
      #(str base %)
      (keys (select-keys m (for [[k v] m :when v] k))))
     base)))

(def ^:private valid-variant? (set -text-variants))

(defn variant->class [variant]
  (str "nosco-text-label--" (-> variant (string/replace "/" "-") (string/lower-case))))

(defnc Text [{:keys [class children el variant truncate title] :or {el :span}} ref]
  (when-not (valid-variant? variant)
    (throw (ex-info (str "Invalid text variant: " variant) {})))
  (let [classes (classnames "nosco-text-label"
                            {"--truncate" truncate})
        classes (conj classes (variant->class variant))]
    [el
     {:class (nosco-react/merge-class class classes)
      :title title
      :ref ref}
     children]))

(nosco.react/forward-ref! Text)
